import { render, staticRenderFns } from "./PropertyDialog.vue?vue&type=template&id=3580a016&scoped=true&"
import script from "./PropertyDialog.vue?vue&type=script&lang=js&"
export * from "./PropertyDialog.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDialog.vue?vue&type=style&index=0&id=3580a016&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3580a016",
  null
  
)

export default component.exports